import { render, staticRenderFns } from "./edit-holiday.vue?vue&type=template&id=4da3d975&"
import script from "./edit-holiday.vue?vue&type=script&lang=js&"
export * from "./edit-holiday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports